import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { FlatOldSaleTypeContainer, MortgageAvailableContainer, NewbuildingSaleTypeContainer } from './containers';
import { selectIsMixedListing, selectIsNewbuildingListing } from 'shared/selectors/jsonQuery';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { InlineFilterSection } from 'shared/components/InlineFilterSection';

export const SaleTypeContainer: FC = () => {
  const isMixedListing = useSelector(selectIsMixedListing);
  const isNewbuildingListing = useSelector(selectIsNewbuildingListing);

  return (
    <AdvancedFilterRow label="Условия продажи">
      {isMixedListing && (
        <>
          <InlineFilterGroup>
            <InlineFilterSection title="На вторичке">
              <FlatOldSaleTypeContainer />
            </InlineFilterSection>
          </InlineFilterGroup>
          <InlineFilterGroup>
            <InlineFilterSection title="В новостройках">
              <NewbuildingSaleTypeContainer />
            </InlineFilterSection>
          </InlineFilterGroup>
        </>
      )}

      {!isMixedListing && (
        <>
          {!isNewbuildingListing && (
            <InlineFilterGroup>
              <MortgageAvailableContainer />
            </InlineFilterGroup>
          )}

          <InlineFilterGroup>
            {isNewbuildingListing ? <NewbuildingSaleTypeContainer /> : <FlatOldSaleTypeContainer />}
          </InlineFilterGroup>
        </>
      )}
    </AdvancedFilterRow>
  );
};
